import { SubAPI } from "./SubAPI";
export class Util extends SubAPI {
    getBackgroundTaskStatus(props) { return this.fetcher.get("/api/util/get-background-task", props); }
}
